import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { RecalculateData } from '../model/recalculate-data';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CalculatorResult } from '../../../models/analysis/solar-calculator-result';

@Component({
  selector: 'psc-recalculate',
  templateUrl: './recalculate.component.html',
})
export class RecalculateComponent implements OnInit, OnChanges {
  @Input() solarCalculatorResult: CalculatorResult;
  @Input() additionalData: boolean = false;

  @Output() recalculate: EventEmitter<RecalculateData> = new EventEmitter<RecalculateData>();

  formGroup: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
  ) {
  }

  ngOnInit() {
    this.formGroup = this.formBuilder.group({
      investment: [this.solarCalculatorResult.investmentCostPerKw, Validators.required],
      systemCapacity: [this.solarCalculatorResult.systemCapacity, Validators.required],
      incomeTax: [this.solarCalculatorResult.incomeTax || 0, Validators.required],
    });
  }

  ngOnChanges() {
    if (!this.formGroup) {
      return;
    }
    this.formGroup.setValue({
      investment: this.solarCalculatorResult.investmentCostPerKw,
      systemCapacity: this.solarCalculatorResult.systemCapacity,
      incomeTax: this.solarCalculatorResult.incomeTax || 0,
    });
    this.formGroup.updateValueAndValidity();
  }


  onSubmit() {
    if (!this.formGroup.valid) {
      return;
    }
    this.recalculate.emit(this.formGroup.value);
  }
}
